
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class RequiredFieldsWarning extends Vue {
  @Prop({ required: false, default: '' }) message!: string;

  @Prop({ required: false, default: true }) isHint!: boolean;
}
